import {Injectable} from '@angular/core';
import {AbstractMapper} from '../../abstract.mapper';
import {Internet, StammdatenInternet} from '@nachdigal';

@Injectable()
export class InternetadresseMapperService extends AbstractMapper<StammdatenInternet, Internet> {

  public getMappedArrayDefaultIndex(source: Array<StammdatenInternet>): number {
    return source.findIndex(value => value.standard);
  }

  protected mapInternal(source: StammdatenInternet): Internet {
    return {internet: source.internet, notiz: source.notiz};
  }
}
